import { render, staticRenderFns } from "./License.vue?vue&type=template&id=b488ec60&scoped=true&"
import script from "./License.vue?vue&type=script&lang=js&"
export * from "./License.vue?vue&type=script&lang=js&"
import style0 from "./License.vue?vue&type=style&index=0&id=b488ec60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b488ec60",
  null
  
)

export default component.exports